import { jsxs as i, jsx as e } from "react/jsx-runtime";
import s from "next/link.js";
import l from "./Icon.js";
const x = ({ ariaLabel: r, href: m, icon: t, notch: a, onClick: o }) => /* @__PURE__ */ i(
  s,
  {
    "aria-label": r,
    className: "relative",
    href: m,
    onClick: o,
    children: [
      /* @__PURE__ */ e(l, { className: "text-lg", name: t }),
      /* @__PURE__ */ e("div", { className: "absolute right-[-0.5rem] top-[-0.625rem] *:font-primary *:h-[1.25rem] *:text-[0.75rem] *:w-[1.25rem]", children: a })
    ]
  }
);
export {
  x as default
};
